module.exports = __webpack_public_path__ + "images/79fc3fe241c079e8ffb41def40134c62.png";